import React from 'react';
import {TextStyle, ViewStyle} from 'react-native';

import {Container, ListNumber, ListText} from './styles';

interface IStepList {
  number?: number;
  text: string;

  containerStyle?: ViewStyle;
  textStyle?: TextStyle;
  numberStyle?: TextStyle;
}

export function StepList({
  number,
  text,
  containerStyle,
  textStyle,
  numberStyle,
}: IStepList) {
  return (
    <Container style={containerStyle}>
      {number && <ListNumber style={numberStyle}>{number}</ListNumber>}
      <ListText style={textStyle}>{text}</ListText>
    </Container>
  );
}
